import { Route, Routes } from 'react-router-dom'

import Overview from './screens/Overview'

const LayoutTemplatesRoutes = () => (
  <Routes>
    <Route path="/" element={<Overview />} />
  </Routes>
)

export default LayoutTemplatesRoutes
